import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const register = async (phoneNumber, password) => {
    try {
      // Check if it's the test account
      if (phoneNumber === '9976543212' && password === 'Bounty@123') {
        const testUser = {
          id: 'test-user',
          phoneNumber: '9976543212',
          username: 'Test User',
          coins: 1000,
          achievements: [],
          rewards: [],
          createdAt: new Date().toISOString()
        };
        setUser(testUser);
        localStorage.setItem('user', JSON.stringify(testUser));
        return { success: true, user: testUser };
      }

      // Check if it's the new demo account
      if (phoneNumber === '9631344510' && password === '55Play@123') {
        const testUser = {
          id: 'test-user-3',
          phoneNumber: '9631344510',
          username: 'Demo User 3',
          coins: 1000,
          achievements: [],
          rewards: [],
          createdAt: new Date().toISOString()
        };
        setUser(testUser);
        localStorage.setItem('user', JSON.stringify(testUser));
        return { success: true, user: testUser };
      }

      // Regular registration logic
      const newUser = {
        id: Date.now().toString(),
        phoneNumber,
        username: `User${Date.now().toString().slice(-4)}`,
        coins: 100,
        achievements: [],
        rewards: [],
        createdAt: new Date().toISOString()
      };
      setUser(newUser);
      localStorage.setItem('user', JSON.stringify(newUser));
      return { success: true, user: newUser };
    } catch (error) {
      console.error('Registration error:', error);
      return { success: false, error: error.message };
    }
  };

  const login = async (identifier, password, rememberPassword = false) => {
    try {
      // Check if it's the test account
      if (identifier === '9976543212' && password === 'Bounty@123') {
        const testUser = {
          id: 'test-user',
          phoneNumber: '9976543212',
          username: 'Test User',
          coins: 1000,
          achievements: [],
          rewards: [],
          createdAt: new Date().toISOString()
        };
        setUser(testUser);
        if (rememberPassword) {
          localStorage.setItem('user', JSON.stringify(testUser));
        }
        return { success: true, user: testUser };
      }

      if (identifier === '9876543210' && password === 'Jalwa@123') {
        const testUser = {
          id: 'test-user-2',
          phoneNumber: '9876543210',
          username: 'Demo User',
          coins: 1000,
          achievements: [],
          rewards: [],
          createdAt: new Date().toISOString()
        };
        setUser(testUser);
        if (rememberPassword) {
          localStorage.setItem('user', JSON.stringify(testUser));
        }
        return { success: true, user: testUser };
      }

      if (identifier === '9631344510' && password === '55Play@123') {
        const testUser = {
          id: 'test-user-3',
          phoneNumber: '9631344510',
          username: 'User 9631****10',
          coins: 1000,
          achievements: [],
          rewards: [],
          createdAt: new Date().toISOString()
        };
        setUser(testUser);
        if (rememberPassword) {
          localStorage.setItem('user', JSON.stringify(testUser));
        }
        return { success: true, user: testUser };
      }

      // Regular login logic
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const userData = JSON.parse(storedUser);
        if (userData.phoneNumber === identifier || userData.email === identifier) {
          setUser(userData);
          if (rememberPassword) {
            localStorage.setItem('user', JSON.stringify(userData));
          }
          return { success: true, user: userData };
        }
      }
      throw new Error('Invalid credentials');
    } catch (error) {
      console.error('Login error:', error);
      throw new Error('Invalid credentials');
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const updateUser = async (updatedUserData) => {
    try {
      const updatedUser = { ...user, ...updatedUserData };
      setUser(updatedUser);
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return { success: true, user: updatedUser };
    } catch (error) {
      console.error('Error updating user:', error);
      return { success: false, error: error.message };
    }
  };

  return (
    <AuthContext.Provider value={{ user, register, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
} 